// Adapted from https://developers.google.com/web/updates/2015/08/using-requestidlecallback

export function requestIdleCallback(callback: IdleRequestCallback, options?: IdleRequestOptions) {
  if (window.requestIdleCallback) {
    return window.requestIdleCallback(callback, options);
  }

  const start = Date.now();
  return setTimeout(() => {
    callback({
      didTimeout: false,
      timeRemaining: () => {
        return Math.max(0, 50 - (Date.now() - start));
      },
    });
  }, 1);
}

export function cancelIdleCallback(handle: number) {
  if (window.cancelIdleCallback) {
    return window.cancelIdleCallback(handle);
  }

  return clearTimeout(handle);
}
